/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Creators as FilterCreators } from '../../../../views/Filters/store';
import { WorkOrderCreators } from '../../../../views/WorkOrders/store';
import useResetDisableNext from '../hooks/usetResetDisableNext';
import { WO_TYPES } from '../../../../constants';
import useFilteredSelectedItem from '../../../Filter/hooks/useFilteredSelectedItem';
import Loader from '../../../Loader/Loader';
import { Div, FlexContainer } from '../../../../globalStyles';
import { Search } from '../../..';
import FilterContainer from '../../../Filter/FilterContainer/FilterContainer';
import FilterTagArea from '../../../Filter/FilterTagArea/FilterTagArea.view';
import Header from '../Header';
import DynamicSVGIcon from '../../../Common/DynamicSVGIcon';
import DropArrow from '../../../../assets/icons/layout/dropdownarrow.svg';
import { HeaderText } from '../../WorkOrderDetails/WorkOrderDetails.style';
import { Bttn } from '../../../../views/WorkOrders/WorkOrders.styles';
import { apiEndPoints } from '../../../../services/axios/endPoints';
import ShowAllTheFilter from '../../../ResultView/ShowAllTheFilter';
import { generateSelectedFilter } from '../../../ResultView/Iframe/generateSelectedFilter';
import CartButton from '../../../Common/CartButton/CartButton';
import FilterSearchComponent from '../../../Filter/FilterSearchComponent/FilterSearchComponent';
import { useActions } from '../../../../store/hooks/useActions';
import { getStringLocale } from '../../../../constants/language';
import { isEmpty } from '../../../../shared/utility/isEmpty';
import Toast from '../../../Common/Toast';

const Step2 = ({ setDisableNext, menuId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // useResetDisableNext(setDisableNext);
  const {
    showFilterResult,
    menuIdofFilter,
    loading,
    resultType,
    cumulativeTags,
    selectedParent,
    assetType,
    filterData,
    inputs,
    placeHolder
  } = useSelector((state) => state.filterData);
  const planDetails = useSelector((state) => state.plansData.planDetails);
  const { type, workOrderCreationFrom } = useSelector(
    (state) => state.upsertWorkOrder
  );

  const error = useSelector((state) => state.configData.error);

  // const [showResult, setShowResult] = useState(false);
  const location = useLocation();
  const { finalMenu } = useSelector((state) => state.home);
  const name = finalMenu.find((ele) => ele.path === location.pathname);
  const { setWorkOrderType, setToastError } = useActions();
  useEffect(() => {
    dispatch(FilterCreators.setMenuIdOfFilter(menuId));
    if (name?.name === 'IDM and Consumable') {
      if (type.workflowTemplateId) {
        dispatch(
          FilterCreators.getFilterData({
            URLparam: `${apiEndPoints.getIdmFilters}/${type.workflowTemplateId}`
          })
        );
      }
    } else {
      dispatch(
        FilterCreators.getFilterData({
          menuId,
          // templateID: type.workflowTemplateId,
          URLparam: `${apiEndPoints.getFilterByWOType}/${type.workflowTemplateId}`
        })
      );
    }
  }, [menuIdofFilter]);

  // useFilteredSelectedItem(setDisableNext);
  const [selectedPath, setSelectedPath] = useState('');
  const isDisabled = useFilteredSelectedItem();
  const { previousLocation } = location.state || {};

  const handleNext = () => {
    if (resultType) {
      dispatch(
        FilterCreators.universalFilterSetter({
          key: 'showFilterResult',
          value: true
        })
      );
    } else {
      const formatedTags = generateSelectedFilter(
        cumulativeTags,
        filterData,
        true
      );
      const payload = {
        menuid: menuIdofFilter,
        tab: selectedParent,
        data: formatedTags,
        inputs: { ...inputs }
      };
      dispatch(
        WorkOrderCreators.getUserDataByTemplateId({
          urlParam: `${apiEndPoints.getUserDataByTemplateId2}/${type.workflowTemplateId}/${assetType}`,
          WFTid: type.workflowTemplateId,
          assetType,
          workOrderCreationFrom,
          scheduleId: planDetails.scheduleId,
          selections: { data: { ...formatedTags }, inputs: { ...inputs } }
        })
      );
      navigate('/home/work_orders/create_WO/form', {
        state: { previousLocation }
      });
    }
  };

  const clearError = () => {
    setToastError('');
  };

  if (showFilterResult) return <ShowAllTheFilter isFullHeight={true} />;
  if (loading) return <Loader />;
  return (
    <>
      <Header>
        {/* <FlexContainer className='ai_center'>
          <Bttn className='white' onClick={() => navigate(-1)}>
            Cancel
          </Bttn>
          <Bttn disabled={isDisabled} onClick={handleNext}>
            Next
          </Bttn>
        </FlexContainer> */}
      </Header>

      <FlexContainer
        px='4'
        className='col'
        style={{
          position: 'relative',
          // minHeight: '76vh',
          height: 'calc(100% - 20rem)',
          backgroundColor: '#FFFFFF',
          margin: '1.5rem',
          borderRadius: '1rem',
          padding: '0.5rem',
          overflow: 'auto'
        }}
      >
        <FlexContainer style={{ height: '100%' }}>
          {/* <p style={{ fontSize: '2rem' }}>{`Select ${type.workflowName}`}</p> */}
          <Div mx='1.5' style={{ width: '100%' }}>
            <FilterSearchComponent
              placeholder={
                placeHolder || getStringLocale('Search For Filters', 'en')
              }
              canToggleFilter={false}
              setSelectedPath={setSelectedPath}
              selectedPath={selectedPath}
            />
          </Div>
        </FlexContainer>
        <Div>
          {/* <FilterTagArea showOnlyTags={true} /> */}
          <div style={{ display: 'none' }}>
            <FilterContainer />
          </div>
        </Div>
      </FlexContainer>
      {error && (
        <Toast className='right' header='Error' message='hi' fn={clearError} />
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '3rem'
        }}
      >
        <Bttn className='white' onClick={() => navigate(-1)}>
          {getStringLocale('Cancel', 'en')}
        </Bttn>
        {/* <Bttn
          disabled={isEmpty(selectedPath) || isDisabled}
          onClick={handleNext}
        > */}
        <Bttn disabled={isDisabled} onClick={handleNext}>
          {getStringLocale('Next', 'en')}
        </Bttn>
      </div>
    </>
  );
};

export default Step2;
